// import action types
import { INIT_CALL_STATE, CLEAR_CALL_STATE, ADD_VERIFIED_MEMBER, UPDATE_CALL_STATE } from 'constants/redux-events';
import { get, concat, uniq } from 'lodash';

/********************************************************/

/**
 * @type {function}
 * @desc A Redux Reducer to manage state of the Redux Store
 * @param {object} [state={}] - Current state of the Redux Store at given state key
 * @param {object} action - Redux **action** object with **event name** and **payload**
 * @example
 * import { callState } from 'reducers/callState';
 */
export const callState = ( state = {}, action ) => {
    const { type, payload = {} } = action;

    switch( type ) {

        // initialize call state
        case INIT_CALL_STATE: {
            return payload;
        }

        // update call state
        case UPDATE_CALL_STATE: {
            return {
				...state,
                ...payload,
			};
        }

        // add verified member to the call state
        case ADD_VERIFIED_MEMBER: {
            const members = get( state, 'members', [] );

            return {
				...state,
                members: uniq( concat( members, payload ) ),
			};
        }

        // wipe all call state
        case CLEAR_CALL_STATE: {
            return {};
        }

        default: {
            return state;
        }
    }
};
